export default {
  EVENT_SETTINGS_UPDATED: 'Evenementinstellingen zijn succesvol bijgewerkt!',
  DAILY_REPORTS_ENABLED: 'Dagelijkse rapporten ingeschakeld',
  EVENT_SETTINGS: 'Evenementinstellingen',
  ARCHIVAL_DAYS: 'Archiefdagen',
  EVENT_ARCHIVAL_DATE: 'Het evenement wordt gearchiveerd op '
}
